import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

export default new Vuex.Store({
	plugins: [createPersistedState({
		storage: window.sessionStorage,
	})],
	state: {
		user: {},
		loggedIn: false,
		loggedOut: false,
		token: null,
		channelId: null,
		signInUser: false,
	},
	getters: {
		user(state) {
			return state.user;
		},
		loggedIn(state) {
			return state.loggedIn;
		},
		loggedOut(state) {
			return state.loggedOut;
		},
		token(state) {
			return state.token;
		},
		channelId(state) {
			return state.channelId;
		},
		signInUser(state) {
			return state.signInUser;
		}
	},
	mutations: {
		SET_LOGGED_IN(state, value) {
			state.loggedIn = value;
		},
		SET_LOGGED_OUT(state, value) {
			state.loggedOut = value;
		},
		SET_USER(state, data) {
			state.user = data;
		},
		SET_TOKEN(state, data) {
			state.token = data;
		},
		SET_CHANNEL(state, data) {
			state.channelId = data;
		},
		SET_SIGNIN_USER(state, value) {
			state.signInUser = value;
		}
	},
	actions: {
		async setUser({ commit }, payload) {
			commit("SET_USER", payload);
		},
		async setChannel({ commit }, payload) {
			commit("SET_CHANNEL", payload);
		},
		async login({ commit }) {
			commit("SET_LOGGED_IN", true);
		},
		async logout({ commit }) {
			commit("SET_LOGGED_IN", false);
			commit("SET_TOKEN", null);
			commit("SET_USER", null);
		},
		async setToken({ commit }, payload) {
			commit("SET_TOKEN", payload);
		},
		async signInUser({ commit }) {
			commit("SET_SIGNIN_USER", true);
		},
		async resetState({ commit }) {
			commit("SET_USER", null);
			commit("SET_LOGGED_IN", false);
			commit("SET_LOGGED_OUT", true);
			commit("SET_SIGNIN_USER", false);
			commit("SET_TOKEN", null);
			commit("SET_CHANNEL", null);
		}
	},
});
